import { t } from "@lingui/core/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetBillingPeriod_memberPackage$key } from "./__generated__/useGetBillingPeriod_memberPackage.graphql";

export const useGetBillingPeriod = (
  memberPackageRef: useGetBillingPeriod_memberPackage$key | null | undefined
) => {
  const memberPackage = useFragment(
    useGetBillingPeriodFragmentString,
    memberPackageRef
  );

  // TODO: This is a place holder until we actually save the chosen billing period
  // We should be using a billing option saved on the member package but that doesn't
  // exist yet
  return memberPackage?.package?.billingType === "ONE_TIME"
    ? undefined
    : t`Monthly`;
};

const useGetBillingPeriodFragmentString = graphql`
  fragment useGetBillingPeriod_memberPackage on MemberPackage {
    id
    package {
      billingType
    }
  }
`;
